import { ApiError } from './ApiError';
import { request } from './request';

const doFetch = async (url, opts) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const isAbsoluteUrl = /^https?:\/\//i.test(url);

  if (backendUrl && !isAbsoluteUrl) {
    // Normalize to avoid double slashes when concatenating base and path:
    // "https://api.example.com/" + "/v1/albums" -> "https://api.example.com/v1/albums"
    const normalizedBase = `${backendUrl}`.replace(/\/+$/, '');
    // Also handles cases like base without trailing slash:
    // "https://api.example.com" + "v1/albums" -> "https://api.example.com/v1/albums"
    const normalizedPath = `${url}`.replace(/^\/+/, '');
    url = `${normalizedBase}/${normalizedPath}`;
  } else {
    url = `${url}`;
  }

  try {
    const res = await fetch(
      url,
      Object.assign({}, request.get, opts)
    );

    if (res.type === 'opaque') {
      return {};
    } else if ([200, 201, 202, 304].includes(res.status)) {
      try {
        return await res.json();
      } catch (error) {
        throw new ApiError('Unexpected error occurred. Received unexpected response.');
      }
    } else if (res.status === 204) {
      return {};
    } else if (res.status === 401) {
      if (
        window.location.pathname.split('/')[2] !== 'login' &&
        window.location.pathname.split('/')[2] !== 'login_failed'  &&
        window.location.pathname.split('/')[1] &&
        !window.location.pathname.includes('reset_password') &&
        !window.location.pathname.includes('confirm/') &&
        !window.location.pathname.includes('claim_import_cost_template_infos') &&
        !/technical_uploads$/.test(window.location.pathname)
      ) {
        // Always go to the global login page; avoid generating paths like
        // /reports/login that clash with `/reports/:id` routes.
        window.location.replace('/login');
      }
      const json = await res.json();
      throw new ApiError(json.errors);
    } else if (res.status === 429) {
      const json = await res.json();
      if (json.redirect_to) {
        window.location.replace(json.redirect_to);
      }
      throw new ApiError(json.errors || json.error || json.status?.message || 'Rate limit exceeded.');
    } else if (res.status === 502) {
      throw new ApiError('Request timed out. Please try again later.');
    } else if (res.status === 413) {
      throw new ApiError('Content too large.');
    } else {
      const json = await res.json();
      let errorData = json.errors || json.error || json.status?.message;
      // Sometimes the above fields are defined, but there is additional useful error information
      // inside the exception field.
      if (Array.isArray(errorData) && json.exception) {
        errorData.push(json.exception)
      } else {
        errorData = `${errorData}`
      }

      throw new ApiError(errorData, json.status || { code: res.status, message: errorData });
    }
  } catch (e) {
    console.log(`Unhandled error for request ${url}`, opts, e.message);
    if (!e.userFriendlyMessages) {
      throw new ApiError(`Could not call ${url}: ${e.message || 'Something unexpected happened.'}`);
    }

    throw e;
  }
};

export default doFetch;
